import React, { Fragment, useState, useEffect } from "react";
import { Card, Form, Spinner, Button, Modal } from "react-bootstrap";
import {  useLocation, useParams, Link } from "react-router-dom";
import Snackbars from "../../../utils/Snackbars";
import useRequests from "../../../utils/useRequests";
import DataTable from "react-data-table-component";
import { CSVLink } from "react-csv";


const ListOrgTicket = () => {
  const location = useLocation();
  const { getRequest, deleteRequest, putRequest } = useRequests();

  const [orgTickets, setOrgTickets] = useState([]);
  const [searchQuery, setSearchQuery] = useState('');

 

  const [AlertData, setAlertData] = React.useState({
    variant: '',
    message: '',
  });

  const resetAlertData = () => {
    setTimeout(() => {
      setAlertData((AlertData) => ({
        ...AlertData,
        variant: '',
        message: '',
      }));
    }, process.env.REACT_APP_ALERT_AUTO_CLOSE);
  };

  const [loading, setLoading] = useState(true);

  const [selectedTicket, setSelectedTicket] = useState(null);
  const [modalType, setModalType] = useState(""); // "enable", "disable", "delete"
  const [showModal, setShowModal] = useState(false);
  const handleOpenModal = (ticket, type) => {
    setSelectedTicket(ticket);
    setModalType(type);
    setShowModal(true);
  };
  const handleCloseModal = () => {
    setShowModal(false);
    setModalType("");
    setSelectedTicket(null);
  };
  
  const [isProcessing, setIsProcessing] = useState(false);
  const handleConfirmAction = async () => {
    if (selectedTicket) {
        setIsProcessing(true);
      if (modalType === "delete") {
        const response = await deleteRequest(`org-ticket-delete/${selectedTicket.t_id}`);
        if (response && response.code === 200) {
          const updatedTickets = orgTickets.filter((ticket) => ticket.t_id !== selectedTicket.t_id);
          setOrgTickets(updatedTickets);
          setAlertData((AlertData) => ({
            ...AlertData,
            variant: 'success',
            message: 'Ticket deleted successfully!',
          }));
          resetAlertData();
        } else {
          console.error("Failed to delete ticket:", response?.message);
          setAlertData((AlertData) => ({
            ...AlertData,
            variant: 'error',
            message: 'Failed to delete ticket',
          }));
          resetAlertData();
        }
      } else if (modalType === "enable" || modalType === "disable") {
        const newStatus = modalType === "enable" ? "Enable" : "Disable";
        try {
          const jsonpar = JSON.stringify({status: newStatus});
          const response = await putRequest(`org-ticket-status/${selectedTicket.t_id}`, jsonpar);
          if (response && response.code === 200) {
            const updatedTickets = orgTickets.map((ticket) =>
                ticket.t_id === selectedTicket.t_id ? { ...ticket, status: newStatus } : ticket
            );
            setOrgTickets(updatedTickets);
            setAlertData((AlertData) => ({
              ...AlertData,
              variant: 'success',
              message: `Ticket ${newStatus}d successfully`,
            }));
            resetAlertData();
          } else {
            console.error("Failed to update status:", response?.message);
            setAlertData((AlertData) => ({
              ...AlertData,
              variant: 'error',
              message: `Failed to ${newStatus} ticket.`,
            }));
            resetAlertData();
          }
        } catch (error) {
          console.error("Error updating status:", error);
          setAlertData((AlertData) => ({
            ...AlertData,
            variant: 'error',
            message: 'Error updating status',
          }));
          resetAlertData();
        }
      }
      setIsProcessing(false);
      handleCloseModal();
    }
  };


  const fetchOrgTickets = async () => {
    const response = await getRequest(`org-tickets-list`); // Replace "users" with the appropriate API endpoint
    if (response && response.code === 200) {
      setOrgTickets(response.data);
    } else {
      console.error("Failed to fetch org tickets:", response.message);
      setAlertData((AlertData) => ({
        ...AlertData,
        variant: 'error',
        message: response.message,
      }));
    }
    resetAlertData();
    setLoading(false);
  };

  useEffect(() => {
    fetchOrgTickets();
    if (location.state && typeof location.state.message !== 'undefined') {
      setAlertData((AlertData) => ({
        ...AlertData,
        variant: location.state.status,
        message: location.state.message,
      }));
      resetAlertData();
      setLoading(false);
    }
  }, []);

  // Filter users based on the search query
  const userOrgTickets = orgTickets.filter((orgTicket) => {
    const phone = `${orgTicket.phone}`.toLowerCase();
    const event = `${orgTicket.name}`.toLowerCase();
    const duration = `${orgTicket.duration} day`;
    const quantity = `${orgTicket.quantity}`;
    const type = `${orgTicket.type}`.toLowerCase();
    const fullName = `${orgTicket.first_name? orgTicket.first_name +" "+orgTicket.last_name : "N/A"}`.toLowerCase();
    const date = new Date(orgTicket.event_ticket_date);
    const formattedDate = date.toLocaleDateString("en-GB", {
      day: "2-digit",
      month: "2-digit",
      year: "numeric",
    });
    const formattedTime = date.toLocaleTimeString("en-GB", {
      hour: "2-digit",
      minute: "2-digit",
    });
    let transaction_date;
    if(formattedDate == "01/01/1970"){
       transaction_date = `-`;
    }else{
       transaction_date = `${formattedDate}`;
    }

    const searchLower = searchQuery.toLowerCase();
  
    return  fullName.includes(searchQuery) ||quantity.includes(searchQuery) || phone.includes(searchQuery) || transaction_date.includes(searchQuery) || event.includes(searchLower) || duration.includes(searchLower) || type.includes(searchLower);
  });

  const columns = [
    {
      name: "Full Name",
      selector: (row) => `${row.first_name? row.first_name +" "+row.last_name : "N/A"}`,
      sortable: true,
      width: "200px" 
    },
    {
        name: "Mobile Number",
        selector: (row) => `${row.phone}`,
        sortable: true,
        width: "200px" 
    },
    {
      name: "Event",
      selector: (row) => `${row.name}`,
      sortable: true,
      width: "150px" 
    },
    {
        name: "Duration",
        selector: (row) => `${row.duration} day`,
        sortable: true,
        width: "150px" 
    },
    {
      name: "Type",
      selector: (row) => row.type,
      sortable: true,
      width: "150px" 
    },
    {
      name: "No. of Tickets",
      selector: (row) => `${row.quantity}`,
      sortable: true,
      width: "150px" 
    },
    {
      name: "Seat Number",
      selector: (row) => `${row.is_seats_required === "Yes" ? row.seat_number : "-"}`,
      sortable: true,
      width: "150px" 
    },
    {
      name: "Date",
      selector: (row) => {
        const date = new Date(row.event_ticket_date);
        const formattedDate = date.toLocaleDateString("en-GB", {
          day: "2-digit",
          month: "2-digit",
          year: "numeric",
        });
        const formattedTime = date.toLocaleTimeString("en-GB", {
          hour: "2-digit",
          minute: "2-digit",
        });
        if(formattedDate == "01/01/1970"){
          return `-`;
        }else{
          return `${formattedDate}`;
        }
      },
      sortable: true,
      width: "150px" 
    },
    {
        name: "Status",
        cell: (row) => (
          <button
            onClick={() =>
              handleOpenModal(row, row.status === "Enable" ? "disable" : "enable")
            }
            className={`btn ${
              row.status === "Enable" ? "btn-success" : "btn-danger"
            } btn-xxs`}
          >
            {row.status === "Enable" ? "Enable" : "Disable"}
          </button>
        ),
        center: true,
        width: "150px",
      },
    {
        name: "Actions",
        cell: (row) => (
        <div className="text-center">
            {/* <Link className="btn btn-primary btn-xxs me-2" to={`/edit-org-ticket/${row.t_id}`} title="Edit Ticket">
            <i className="fa-regular fa-pen-to-square"></i>
            </Link> */}
            <button className="btn btn-danger btn-xxs me-2" onClick={() => handleOpenModal(row, "delete")}  title="Delete Ticket">
            <i className="fa-solid fa-trash"></i>
            </button>
        </div>
        ),
        center: true,
        width: "220px",
    },
  ];

  const customStyles = {
    header: {
      style: {
        minHeight: "56px",
      },
    },
    headCells: {
      style: {
        color: "#341439",
        fontSize: "17px",
        fontWeight: "600",
        paddingLeft: "8px", // Adjust padding
        paddingRight: "8px",
      },
    },
    cells: {
      style: {
        fontSize: "16px",
        padding: "12px 9px",
        color: "#7E7E7E",
      },
    },
    pagination: {
      style: {
        fontSize: "16px",
      },
    },
  };


  return (
    <Fragment>
        {AlertData.message !== "" ? (
          <Snackbars variant={AlertData.variant} message={AlertData.message} />
        ) : (
          ""
        )}
      <div className='d-sm-flex d-block justify-content-between align-items-center mb-4'>
        <h2 className='text-black font-w600 mb-0'>Org Tickets</h2>
        <Link
            to='/add-org-ticket'
            type='button'
            className='btn btn-rounded btn-primary'
        >
            Assign Ticket
        </Link>
      </div>

      {/* Search input */}
      <div className='mb-4 d-sm-flex d-block justify-content-end'>
      <div style={{ position: "relative", width: "18rem" }}>
  <Form.Control
    type="text"
    placeholder="Search..."
    value={searchQuery}
    onChange={(e) => setSearchQuery(e.target.value)}
    style={{
      width: "100%",
      fontSize: "18px",
      fontWeight: 500,
      paddingRight: "2rem",
      borderRadius:'0.625rem',
      height:'3.2rem' // Add padding to ensure the icon doesn't overlap text
    }}
  />

  <i
    className="fa fa-search"
    style={{
      position: "absolute",
      right: "10px", // Distance from the right edge of the input
      top: "50%",
      transform: "translateY(-50%)", // Center vertically
      color: "#6c757d", // Optional: color for the icon
      pointerEvents: "none", // Makes sure clicks pass through to the input
    }}
  ></i>

</div>

      </div>

      <Card>
        <Card.Body>
          {loading ? (
                <div className='text-center'>
                  <Spinner animation='border' />
                  <p>Loading...</p>
                </div>) : 
          (<DataTable
            columns={columns}
            data={userOrgTickets} // Use filtered data
            customStyles={customStyles}
            pagination
            highlightOnHover
            responsive
          />)}
        </Card.Body>
      </Card>

      {/* Enable/Disable/Delete Modal */}
      <Modal show={showModal} onHide={handleCloseModal} centered>
        <Modal.Header closeButton>
          <Modal.Title>
            {modalType === "enable" && "Enable Ticket"}
            {modalType === "disable" && "Disable Ticket"}
            {modalType === "delete" && "Delete Ticket"}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {modalType === "delete" ? (
            <>
              Are you sure you want to delete the Ticket of{" "}
              <strong>
                {selectedTicket?.first_name? selectedTicket?.first_name +" "+ selectedTicket?.last_name : selectedTicket?.phone}
              </strong>
              ? This action cannot be undone.
            </>
          ) : (
            `Are you sure you want to ${modalType} the Ticket?`
          )}
        </Modal.Body>
        <Modal.Footer>
          <Button variant='light' onClick={handleCloseModal}>
            Cancel
          </Button>
          <Button
            className={`btn btn-${
              modalType === "enable"
                ? "success"
                : modalType === "disable"
                ? "danger"
                : "danger"
            }`}
            onClick={handleConfirmAction}
            disabled={isProcessing}
          >
            {modalType === "enable" && "Enable"}
            {modalType === "disable" && "Disable"}
            {modalType === "delete" && "Delete"}
          </Button>
        </Modal.Footer>
      </Modal>
    </Fragment>
  );
};

export default ListOrgTicket;
